import { IValue } from './ivalue';
import { ControlType } from '../controltype';
import { EventEmitter } from '@angular/core';

export class DateRangeTimeValue implements IValue {
    startTime: string;
    endTime: string;
    clear$ = new EventEmitter();

    constructor(value: { startTime: string, endTime: string } = { startTime: '', endTime: '' }) {
        this.startTime = value.startTime;
        this.endTime = value.endTime;
    }
    isEmpty(): boolean {
        return !this.startTime || !this.endTime;
    }

    setOriginalValue(value: { formatted: string, delimiter: string }): void {
        if (value.formatted) {
            this.startTime = value.formatted.split(value.delimiter)[0];
            this.endTime = value.formatted.split(value.delimiter)[1];
        } else {
            this.clearValue();
        }
    }
    getOriginalValue() {
        return `${this.startTime}~${this.endTime}`;
    }
    getControlType(): ControlType {
        return ControlType.DateRangeTime;
    }
    clearValue(): void {
        this.startTime = undefined;
        this.endTime = undefined;

        this.clear$.emit();
    }
}

